import styled from 'styled-components'

const getRiskLevelColor = (riskLevel: string) => {
  switch (riskLevel) {
    case 'Unknown':
      return '#B63C3C'
    case 'Low':
      return '#45D5B4'
    case 'Acknowledged Medium':
      return '#B63C3C'
    case 'Medium':
      return '#B63C3C'
    case 'Acknowledged High':
      return '#FA5252'
    case 'High':
      return '#FA5252'
    default:
      return '#B63C3C'
  }
}

export const RiskLevel = styled.span<{ $riskLevel: string }>`
  font-weight: bold;
  color: ${(p) => getRiskLevelColor(p.$riskLevel)};
`
